"use strict";

// 本のカスタムリンク表示
export const BOOK_SORT_ORDER_CUSTOM = 5;

// 子カテゴリのカスタムリンク表示
export const CHILD_SORT_ORDER_CUSTOM = 3;

// カテゴリの余幅（調整値）
export const CATEGORY_MARGIN_WIDTH = 1;

// 詳細表の高さの基準値
export const DEFAULT_IMAGE_HEIGHT = 1050;

// タテオキのタブ名
export const TATEOKI_TAB_NAME = "org-tateoki";

// 棚のデフォルトビュー
export const DEFAULT_VIEW_SELECTOR = ".main";

// 本の並び替えポップアップ設定
export const BOOK_SORT = {
  SUPPRESS_DURATION: 200, // ポップアップ再オープン抑止時間(ms)
  MIN_BOOKS_FOR_SORT: 5, // ソート表示に必要な最小書籍数
  POPUP_OFFSET: 8, // 画面端からのオフセット
  Z_INDEX: 20000,
};

// アニメーションの時間設定（ミリ秒）
export const ANIMATION_DURATION = {
  CATEGORY_OPEN: 200,
  FADE: 500,
  VIEW_SCROLL_ARROW: 1000,
  TIMEOUT: 3000,
};

// アニメーション完了理由
export const ANIMATION_FINISH_REASON = {
  REACHED_TARGET: "reached target",
  EDGE_REACHED: "edge reached without hitting target",
  CANNOT_SCROLL: "cannot scroll",
  ALREADY_AT_TARGET: "already at target",
  ALREADY_AT_MAX: "already at max",
  ALREADY_AT_MIN: "already at min",
  TIMEOUT: "timeout",
};

// 多階層種別
export const MULTI_LAYER = Object.freeze({
  CATEGORY: 1, // カテゴリ（索引）
  BOOK: 2, // ブック（背表紙）
});

// moveAnimation(), getElementAtPosition() で使用する位置種別
export const ELEMENT_POSITION = Object.freeze({
  LEFT: 1,
  CENTER: 2,
  RIGHT: 3,
  CUSTOM: 4,
});

// 画像パス管理
export const IMAGE_PATH = {
  VERTICAL_SCROLL_HINT: "https://bookreview.s3.ap-northeast-1.amazonaws.com/images/scroll_guide/up_down.png",
};
